export default __webpack_public_path__ + "static/media/advangtageabsoluteprecision.f0159489.png";